import {
  Footer,
  Header,
  Modal,
  ModalBurgerContent,
  // PasswordsForm,
  // ResetPasswordForm,
  SignInForm,
  SignUpForm,
} from '@components';
import { useScreenSize } from '@hooks';
import Noise from '@pngs/Noise5.png';
import { Flex, theme } from '@styles';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { rootPageLayoutByVariant } from './RootPageTemplate.layoutProps';

const RootPageTemplate = () => {
  const { device, isTabletLG, isTabletSM } = useScreenSize();

  const layout = rootPageLayoutByVariant[device];
  const [isModalVisible, setModalVisible] = useState(false);
  const [isModalBurgerVisible, setIsModalBurgerVisible] = useState(false);
  const authModalState = useSelector((state) => state.authSlice.authModalState);

  const closeModalBurger = () => {
    setIsModalBurgerVisible(0);
  };
  const handleLogInButtonClick = () => {
    closeModalBurger();
    setModalVisible(true);
  };

  const handleModalClose = () => {
    document.body.style.overflow = 'unset';
    setModalVisible(false);
  };

  const modalLayoutByState = {
    // Removed due to changes in auth logic
    // emailForm: <ResetPasswordForm />,
    // resetPassword: <PasswordsForm />,
    signIn: <SignInForm onSignInButtonClick={handleModalClose} />,
    signUp: <SignUpForm onSignUpButtonClick={handleModalClose} />,
  };

  return (
    <Flex
      backgroundImage={Noise}
      backgroundSize="contain"
      flexDirection="column"
      overflow="hidden"
      width="100%"
    >
      <Modal
        isVisible={isModalVisible}
        modalContainerProps={{
          borderRadius: isTabletSM ? '0px' : '8px',
          height: '100%',
          maxHeight: isTabletSM ? '100%' : '618px',
        }}
        modalMaxHeight="100%"
        setModalVisible={setModalVisible}
        withBackdropNoise={!isTabletSM}
      >
        {modalLayoutByState[authModalState]}
      </Modal>
      {isTabletLG && (
        <Modal
          isVisible={isModalBurgerVisible}
          justifyContent="center"
          modalContainerProps={{
            backgroundColor: theme.colors.background,
            borderRadius: '0 !important',
            height: '100%',
            maxHeight: '100%',
            maxWidth: '100%',
            padding: '16px',
            width: '100%',
          }}
          modalMaxHeight="100%"
          setModalVisible={setIsModalBurgerVisible}
        >
          <ModalBurgerContent
            closeModal={closeModalBurger}
            containerProps={layout?.header}
            logInButtonClick={handleLogInButtonClick}
          />
        </Modal>
      )}
      <Header
        containerProps={layout?.header}
        logInButtonClick={handleLogInButtonClick}
        onBurgerClick={() => setIsModalBurgerVisible(1)}
      />
      <Outlet />
      <Footer logInButtonClick={handleLogInButtonClick} />
    </Flex>
  );
};

export default RootPageTemplate;
